const URL_PDF = 'https://www.openbank.es/assets/static/nl/pdf/';
const LEGAL_INFO_A = URL_PDF + 'footer/Legal_information_NL.pdf';
const WEALTH_RATE = URL_PDF + 'Investments/Wealth_rate_NL_2.pdf';

const generatePdf = urlsPdfs => {
    return [LEGAL_INFO_A, ...urlsPdfs, WEALTH_RATE];
};

export default {
    generatePdf,
};
